import React from 'react';
import withStyles from 'components/common/wrappers/withStyles';

const Checkmark = ({ width, height, color, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <path xmlns="http://www.w3.org/2000/svg" id="Vector" d="M15 10L11 14L9 12M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>

    </svg>
  );
};

Checkmark.defaultProps = {
  color: 'white',
};

export default withStyles(Checkmark);